import * as translate from './translate.js';
import * as translateLang from './translate_lang.js';

export default {
    translate,
    translateLang,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Translate
    window.EQLAPP.TRANSLATE = window.EQLAPP.TRANSLATE || {};
    Object.entries(translate).forEach(([key, value]) => {
        window.EQLAPP.TRANSLATE[key] = value;
    });

    // Translate
    window.EQLAPP.LANG = window.EQLAPP.LANG || {};
    Object.entries(translateLang).forEach(([key, value]) => {
        window.EQLAPP.LANG[key] = value;
    });

}
